import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const ApplicationMenuWrapper = ({ open, closeMenu, children }) => (
    <nav className={`ckp-application-menu ${open ? 'is-open' : ''}`}>
        <IconButton className="ckp-modal-full-close" onClick={closeMenu} color="inherit">
            <CloseIcon />
        </IconButton>
        <div className="ckp-application-menu-body">{children}</div>
    </nav>
);

export default ApplicationMenuWrapper;



// WEBPACK FOOTER //
// ./src/components/application/menu/ApplicationMenuWrapper.js